import Grid2 from '@mui/material/Unstable_Grid2';
import { Step } from '../../components/Step';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { TextField } from 'src/shared/components/Form/TextField';
import { Button } from '@mui/material';
import { type ConnectPersonioArgs } from 'src/shared/api/integrations/personio';

type Step1Props = {
  triggerConnection: (args: ConnectPersonioArgs) => void;
};

export const Step1 = ({ triggerConnection }: Step1Props) => {
  const {
    values: { subsidiary, clientId, clientSecret }
  } = useFormState();
  const { t } = useTranslation('settings');

  return (
    <Step
      title={`${t('integrations.step')} 1`}
      subtitle={`${t('integrations.personio.create new api credentials')}:`}
      Icon={VpnKeyIcon}
    >
      <>
        <Grid2 xs={12}>
          <TextField sx={{ width: '300px' }} label={t('integrations.client id')} name="clientId" />
        </Grid2>
        <Grid2 xs={12}>
          <TextField sx={{ width: '300px' }} label={t('integrations.secret')} name="clientSecret" />
        </Grid2>
        <Grid2 xs={12}>
          <Button
            variant="contained"
            onClick={() => {
              triggerConnection({ subsidiary, body: { clientId, clientSecret }, noAutoLogout: true });
            }}
            disabled={!clientId || !clientSecret}
          >
            {t('integrations.connect')}
          </Button>
        </Grid2>
      </>
    </Step>
  );
};
